
//Wrap Umbraco Embed iframes if they are Youtube Videos
function wrapUmbracoEmbedVideo() {
    var $iframe = $(".rte-content iframe");

    $iframe.each(function (e) {
        var $self = $(this);
        var attr = $self.attr("allowfullscreen");

        //If iframe has the attribute "allowfullscreen" we assume its a video and add the embed-container class to its parent element
        //The goal is to show the iframe in 16:9 aspect and make it responsive
        if (typeof attr !== typeof undefined && attr !== false) {
            $iframe.parent().addClass("embed-container");
        }
    });
}

$(function () {
    wrapUmbracoEmbedVideo();
});
